export const nameCapitalized = (name) => {
    if (name === null) return ''
    return name?.charAt(0).toUpperCase() + name?.slice(1)
}
